import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Brand, Container, Foot, Header } from '../Portfolio/styles';
import { Main, SkipLink } from './styles';
import { LayoutProps } from './types';

export default function Layout({ children }: LayoutProps) {
  useEffect(() => {
    document.documentElement.classList.add('ready');
  }, []);

  return (
    <>
      <SkipLink href="#main-content">Skip to content</SkipLink>
      <Header>
        <Container>
          <Brand to="/" aria-label="Guilherme Niclewicz, home">
            gn.
          </Brand>
          <nav aria-label="Main navigation">
            <Link to="/#work">Work</Link>
            <Link to="/#experience">Experience</Link>
            <Link to="/writing">Writing</Link>
            <Link to="/#contact">Contact</Link>
          </nav>
        </Container>
      </Header>
      <Main id="main-content" tabIndex={-1}>
        {children}
      </Main>
      <Foot>
        <Container>
          <p>© {new Date().getFullYear()} Guilherme Niclewicz</p>
          <p>Built with care. Operated by me.</p>
        </Container>
      </Foot>
    </>
  );
}
